import _ from 'underscore';

const msToMinutesAndSeconds = (milliseconds) => {
  let minutes = Math.floor(milliseconds / 60000);
  let seconds = ((milliseconds % 60000) / 1000).toFixed(0);
  return seconds === 60 ? minutes + 1 + ':00' : minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};

export const getTimeOfRun = (input, ticket, isExternalDate) => {
  let runTime = isExternalDate
    ? new Date(isExternalDate)
    : new Date(input.timeOfRequest || input.timeOfPaste || input.updatedAt);
  let startTime = new Date(ticket.startedAt);
  return msToMinutesAndSeconds(runTime - startTime);
};

export const getMaxScore = (input) => {
  return _.reduce(
    input.levelMaxScores,
    function (memo, num) {
      return memo + (num ? num : 0);
    },
    0
  );
};

export const getScore = (input) => {
  return _.reduce(
    input.levelScores,
    function (memo, num) {
      return memo + (num ? num : 0);
    },
    0
  );
};

export const getWholeScore = (input) => {
  let maxScore = getMaxScore(input);
  let userScore = getScore(input);

  return input.levelScores ? userScore + ' / ' + maxScore : 'No score available';
};
